module.exports = __webpack_public_path__ + "static/media/natural-stone.3a487999.svg";